import { Controller } from "@hotwired/stimulus"

// Toggles a truncated comment/reply body between its preview and full text
// inline, without navigating away to the record's show page.
export default class extends Controller {
  static targets = ["preview", "full", "toggleLink"]

  toggle(event) {
    event.preventDefault()

    const expanded = this.fullTarget.hidden
    this.previewTarget.hidden = expanded
    this.fullTarget.hidden = !expanded
    this.toggleLinkTarget.textContent = expanded ? "Hide" : "Show"
  }
}
